/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ScorerInputs */

const th_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้บันทึกคะแนน`)
};

const en_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorer`)
};

const ja_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録員`)
};

const zh_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`记录员`)
};

const es_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anotador`)
};

const pt_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apontador`)
};

const id_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencatat skor`)
};

const fr_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marqueur`)
};

const tl_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagatala ng iskor`)
};

const vi_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người ghi biên bản`)
};

const ko_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기록원`)
};

const de_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiber`)
};

const ru_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Секретарь`)
};

const tr_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skorer`)
};

const it_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnapunti`)
};

const pl_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekretarz`)
};

const uk_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Секретар`)
};

const hi_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्कोरर`)
};

const ar_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المسجّل`)
};

const ms_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencatat mata`)
};

const bn_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোরার`)
};

const zh_tw2_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記錄員`)
};

const zh_hk2_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記錄員`)
};

const ur_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکورر`)
};

const fa_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثبت‌کنندهٔ نتیجه`)
};

const sw_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwandishi wa matokeo`)
};

const nl_scorer = /** @type {(inputs: ScorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notulist`)
};

/**
* | output |
* | --- |
* | "Scorer" |
*
* @param {ScorerInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const scorer = /** @type {((inputs?: ScorerInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ScorerInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_scorer(inputs)
	if (locale === "ja") return ja_scorer(inputs)
	if (locale === "zh") return zh_scorer(inputs)
	if (locale === "es") return es_scorer(inputs)
	if (locale === "pt") return pt_scorer(inputs)
	if (locale === "id") return id_scorer(inputs)
	if (locale === "fr") return fr_scorer(inputs)
	if (locale === "tl") return tl_scorer(inputs)
	if (locale === "vi") return vi_scorer(inputs)
	if (locale === "ko") return ko_scorer(inputs)
	if (locale === "de") return de_scorer(inputs)
	if (locale === "ru") return ru_scorer(inputs)
	if (locale === "tr") return tr_scorer(inputs)
	if (locale === "it") return it_scorer(inputs)
	if (locale === "pl") return pl_scorer(inputs)
	if (locale === "uk") return uk_scorer(inputs)
	if (locale === "hi") return hi_scorer(inputs)
	if (locale === "ar") return ar_scorer(inputs)
	if (locale === "ms") return ms_scorer(inputs)
	if (locale === "bn") return bn_scorer(inputs)
	if (locale === "zh-TW") return zh_tw2_scorer(inputs)
	if (locale === "zh-HK") return zh_hk2_scorer(inputs)
	if (locale === "ur") return ur_scorer(inputs)
	if (locale === "fa") return fa_scorer(inputs)
	if (locale === "sw") return sw_scorer(inputs)
	if (locale === "nl") return nl_scorer(inputs)
	return en_scorer(inputs)
});